import { alpha } from "@mui/material";
import { LEZ_COLOR } from "src/config";
import styled from "styled-components";

export const PredefinedLEZsLegend = styled.div`
  width: 20px;
  height: 20px;
  border: 2px solid ${LEZ_COLOR};
  background-color: ${alpha(LEZ_COLOR, 0.2)};
`;
